import { LitElement, PropertyValueMap, html } from "lit";
import { customElement } from "lit/decorators.js";
import { i18n } from "./utils/i18n.js";
import { setupLiveReload } from "./utils/live-reload.js";
import { router } from "./utils/routing.js";

export * from "./pages/index.js";
export * from "./utils/ui-components.js";

setupLiveReload();

@customElement("app-main")
export class App extends LitElement {
    constructor() {
        super();
    }

    protected createRenderRoot(): Element | ShadowRoot {
        return this;
    }

    protected firstUpdated(_changedProperties: PropertyValueMap<any> | Map<PropertyKey, unknown>): void {
        super.firstUpdated(_changedProperties);
        
        router.addRoute(
            "/",
            () => html`<main-page></main-page>`,
            () => "AppShovel"
        );
        
        router.addRoute(
            "/404",
            () => html`${i18n("Whoops, that page doesn't exist")}`,
            () => "404"
        );
        router.addRoute(
            "/imprint",
            () => html`<imprint-page></imprint-page>`,
            () => "AppShovel | Imprint"
        );
        router.addRoute(
            "/terms",
            () => html`<terms-page></terms-page>`,
            () => "AppShovel | Terms"
        );
        router.addRoute(
            "/privacy",
            () => html`<privacy-page></privacy-page>`,
            () => "AppShovel | Privacy"
        );

        router.addRoute(
            "/login",
            () => html`<login-page></login-page>`,
            () => "AppShovel | Login"
        );
        router.addRoute(
            "/pricing",
            () => html`<pricing-page></pricing-page>`,
            () => "AppShovel | Pricing"
        );
        router.addRoute(
            "/search",
            () => html`<search-page></search-page>`,
            () => "AppShovel | Search",
            true,
        );
        router.addRoute(
            "/settings",
            () => html`<settings-page></settings-page>`,
            () => "AppShovel | Settings",
            true,
        );
        
        router.setRootRoute("/");
        router.setNotFoundRoot("/404");
        router.setAuthProvider(isAuthenticated);
        router.replace(location.pathname);
    }
}

export function isAuthenticated() {
    const authTokenExpiration = document.cookie.split('; ').find(row => row.startsWith('authTokenExpiration='));
    if (!authTokenExpiration) return false;
    return new Date().getTime() < parseInt(authTokenExpiration.split('=')[1]);
}

export function isProduction() {
    return window.location.hostname === 'appshovel.com';
}
